exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".innerContainer{border-radius:13px;background-color:#fff;border-color:#e6e6e6!important;border-top-style:solid;border-top-width:1px;border-left-style:solid;border-left-width:1px;border-right-style:solid;border-right-width:1px;border-bottom-style:solid;border-bottom-width:1px}.no-pm{padding:0!important;margin:0!important}.black-label label{color:red!important;font-weight:700;font-size:1.2em}.black-label .theme--light.v-icon{color:red;color:red!important;caret-color:red!important}.text-m-center{text-align:center!important;font-weight:700;text-transform:uppercase}", ""]);

// exports
